import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { IconButton, Icon, Panel } from 'rsuite'
import BudgetForm from '../../../components/forms/budgetForm/BudgetForm'
import BudgetTableView from '../../../components/forms/budgetForm/BudgetTableView'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import {
  getBudgetCategoryByCategoryId,
  saveBudgetCategory,
  updateBudgetCategory,
  deleteBudgetCategory,
  saveProjectBudget,
  updateProjectBudget,
  deleteProjectBudget,
  getProjectBudgetRefresh,
} from '../../../redux/actions/budget'
import { startLoading, doneLoading } from '../../../utils/loading'
import { getSchemaSidebar } from '../../../redux/actions/sidebar'
import WarningMessage from '../../../components/message/WarningMessage/WarningMessage'
import moment from 'moment'
import { RETRY_CONTACT_ADMIN } from '../../../constants/msgText'
import { DATE_PICKER_FORMAT } from '../../../constants/date'

export default function BudgetWidgets({ projectVersionId, ...props }) {
  const { showCommandButton, bordered, shaded, getSummary, onClickExpanded } = props
  const { isEdit, onChangeIsEdit } = props
  const [section, setSection] = useState()
  // const [isEdit, setIsEdit] = useState(false)
  const [isError, setIsError] = useState(false)
  const [isDeleteError, setIsDeleteError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, clearErrors, getValues } = useForm()
  const [formSchema, setFormSchema] = useState(props.schema)
  const [formKey, setFormKey] = useState(props.formKey)
  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = projectVersionId || sessionStorage.getItem('projectId')
  const [panelExpanded, setPanelExpanded] = useState()
  const [txtButton, setTxtButton] = useState(props?.schema?.header?.split(' '))
  const [delErrorMsg, setDelErrorMsg] = useState()
  const [errorMsg, setErrorMsg] = useState()

  useEffect(() => {
    let boolEx = onClickExpanded
    if (formSchema.values?.length <= 0) {
      boolEx = false
    } else {
      boolEx = true
    }
    setPanelExpanded(boolEx)
  }, [onClickExpanded])

  const handleUpdateSave = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError()
    setErrorMsg('')
    try {
      let response
      if (request.id) {
        //console.log('call update.')
        response = await updateProjectBudget(projectId, request)
      } else {
        // console.log('call save.')
        response = await saveProjectBudget(projectId, request)
      }
      console.log('response', response)
      if (response) {
        setFormSchema(response)
        getSummary()
        await dispatch(getSchemaSidebar(projectId))
      } else {
        setIsError(true)
        setErrorMsg('')
      }
    } catch (e) {
      //console.log('e', e)
      setErrorMsg(e?.response?.data?.errorMessage)
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleDelete = async (row) => {
    startLoading()
    setIsLoading(true)
    setIsDeleteError(false)
    setDelErrorMsg('')
    try {
      console.log('call delete.')
      const status = await deleteProjectBudget(projectId, row.categoryId, row.id)
      // console.log(status)
      if (status === 200) {
        // console.log('call get.')
        const _schema = await getProjectBudgetRefresh(projectId, row.categoryId)
        getSummary()
        setFormSchema(_schema)
        await dispatch(getSchemaSidebar(projectId))
      } else {
        setIsDeleteError(true)
        setDelErrorMsg(`${ERR_MSG}ลบไม่สำเร็จ ${RETRY_CONTACT_ADMIN}`)
      }
    } catch (e) {
      //console.log('e', e)
      setIsDeleteError(true)

      let data = e?.response?.data

      //console.log('data', data)
      if (data?.status == 500) {
        //console.log('data?.errorMessage', data?.errorMessage)
        setDelErrorMsg(data?.errorMessage || `${ERR_MSG} ${RETRY_CONTACT_ADMIN}`)
      }
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    //console.log('onSubmit data', data)

    let request = {
      id: data.selectedId,
      categoryId: formSchema.categoryId,
      categoryType: formSchema.categoryType,
      costName: data.costName || '',
      subCostName: data.subCostName || '',
      costDetail: data.costDetail || '',
      startDate: moment(data.startDate).format(DATE_PICKER_FORMAT) || '',
      endDate: moment(data.endDate).format(DATE_PICKER_FORMAT) || '',
      costPerUnit: data.costPerUnit || 0,
      quantity: data.quantity || 0,
      unitOfMeasure: data.unitOfMeasure || '',
      personelVatType: data.personelVatType || '',
      costPerVat: data.costPerVat || 0,
      sumPrice: (parseFloat(data.quantity) * parseFloat(data.costPerUnit)).toLocaleString('en-US', {
        maximumFractionDigits: 2,
      }),
    }

    console.log('request', request)
    handleUpdateSave(request)
  }

  // const onDelete = (index) => {
  //   let dataList = [...formSchema.values]
  //   handleDelete(dataList[index])
  // }

  const onDelete = (id) => {
    let row = formSchema.values.find((row) => row.id === id)

    handleDelete(row)
  }

  const onBackToView = () => {
    console.log('onBackToView', formSchema.values)

    setFormSchema((state) => ({
      ...state,
    }))
    setIsError(false)
    setIsDeleteError(false)
    onChangeIsEdit(!isEdit)
    scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
  }

  return (
    <Panel
      shaded={shaded}
      bordered={bordered}
      header={
        <div
          onClick={(e) => {
            setPanelExpanded(!panelExpanded)
          }}
        >
          {formSchema.header}
        </div>
      }
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
      onClick={(e) => {
        if (e.target.className === 'rs-panel-heading' || e.target.className === 'collapsed') {
          setPanelExpanded(!panelExpanded)
        }
      }}
      style={{ marginBottom: 20 }}
      expanded={panelExpanded}
    >
      <WarningMessage style={{ marginTop: -10 }} message={formSchema?.feedbackBySubject} />

      {isEdit && showCommandButton ? (
        <BudgetForm
          hideHeader={true}
          schema={formSchema}
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          setValue={setValue}
          clearErrors={clearErrors}
          onSubmit={handleSubmit(onSubmit)}
          onDelete={onDelete}
          isError={isError}
          errorMsg={errorMsg}
          isDeleteError={isDeleteError}
          setIsDeleteError={setIsDeleteError}
          delErrorMsg={delErrorMsg}
          loading={isLoading}
          formKey={formKey}
          getValues={getValues}
          projectVersionId={projectVersionId}
        />
      ) : (
        <>{formSchema && <BudgetTableView schema={formSchema} />}</>
      )}

      {showCommandButton && (
        <>
          <hr />

          {isEdit ? (
            <div>
              <IconButton
                appearance="ghost"
                className="rs-btn-ghost-info"
                icon={<Icon className="bt-gost-icon-radius-info" icon="backward" />}
                onClick={onBackToView}
              >
                {/* {'ดูรายการ ' + (formSchema.buttonText ? formSchema.buttonText : '')} */}
                {'กลับไปดู ' + (formSchema.header ? txtButton[1] : '')}
              </IconButton>
            </div>
          ) : (
            <IconButton
              appearance="ghost"
              className="rs-btn-ghost-edit"
              onClick={() => {
                onChangeIsEdit(!isEdit)
                setIsDeleteError(false)
                setIsError(false)
                scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
              }}
              icon={<Icon className="bt-gost-icon-radius-edit" icon="edit" />}
            >
              {'เพิ่ม/แก้ไข ' + (formSchema.header ? txtButton[1] : '')}
            </IconButton>
          )}
        </>
      )}
    </Panel>
  )
}
